import script from "./GameLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./GameLayout.vue?vue&type=script&setup=true&lang=js"

import "./GameLayout.vue?vue&type=style&index=0&id=70e307f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e307f8"]])

export default __exports__